import type { ComponentType } from 'react';
import React from 'react';
import logger from 'Logger/logger';
import { ErrorBoundary } from 'Context/ErrorBoundary';
import { hasComponent, getComponent } from 'Cms/descriptors';
export type LineProps = {
  dataTestIdPrefix?: string;
  id?: number;
  name?: string;
  component?: ComponentType<any>;
  pageLines?: ReadonlyArray<LineProps>;
  props: {
    lines?: ReadonlyArray<LineProps>;
    [propKey: string]: any;
  };
};
export const Line = ({
  dataTestIdPrefix,
  id,
  name,
  component,
  pageLines = [],
  props: { lines = [], ...props },
}: LineProps) => {
  if (!component && !hasComponent(name) && lines.length === 0) {
    logger.warn(`Line without Component ${String(id)} / ${String(name)}`);
    return null;
  }

  const Component = (component || getComponent(name)) as ComponentType<any> | null;

  if (Component) {
    return (
      <ErrorBoundary key={id}>
        {/* TODO(TS-ZERO): tighten getComponent return type instead of casting */}
        <Component
          {...props}
          dataTestIdPrefix={dataTestIdPrefix}
          lines={lines}
          pageLines={pageLines}
        >
          {lines.map((line) => (
            <Line
              {...line}
              dataTestIdPrefix={dataTestIdPrefix}
              key={line.id}
              pageLines={pageLines}
            />
          ))}
        </Component>
      </ErrorBoundary>
    );
  }

  return (
    <ErrorBoundary key={id}>
      {lines.map((line) => (
        <Line {...line} dataTestIdPrefix={dataTestIdPrefix} key={line.id} pageLines={pageLines} />
      ))}
    </ErrorBoundary>
  );
};
